module.exports = __webpack_public_path__ + "img/casino_pinpoint.72aa71a2.svg";